import script from "./CourseList.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseList.vue?vue&type=script&setup=true&lang=js"

import "./CourseList.vue?vue&type=style&index=0&id=592f651c&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-592f651c"]])

export default __exports__